import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, ListChecks, Users, Package, FolderTree,
  ScanLine, Sparkles, Settings as SettingsIcon, BarChart3, LogOut,
  Layers, Boxes, FileText, Image as ImageIcon,
} from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

const NAV = [
  { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard, key: "dashboard" },
  { to: "/admin/leads", label: "Leads", icon: ListChecks, key: "leads" },
  { to: "/admin/reps", label: "WhatsApp Reps", icon: Users, key: "reps" },
  { to: "/admin/banners", label: "Header Banners", icon: ImageIcon, key: "banners" },
  { to: "/admin/products", label: "Products", icon: Package, key: "products" },
  { to: "/admin/combos", label: "Combos", icon: Boxes, key: "combos" },
  { to: "/admin/collections", label: "Collections", icon: Layers, key: "collections" },
  { to: "/admin/categories", label: "Concern Cards", icon: FolderTree, key: "categories" },
  { to: "/admin/concerns", label: "Concerns", icon: ScanLine, key: "concerns" },
  { to: "/admin/routines", label: "Routine Rules", icon: Sparkles, key: "routines" },
  { to: "/admin/forms", label: "Form Builder", icon: FileText, key: "forms" },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3, key: "analytics" },
  { to: "/admin/settings", label: "Settings", icon: SettingsIcon, key: "settings" },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-brand-bone flex">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 bg-white border-r border-brand-line min-h-screen flex flex-col" data-testid="admin-sidebar">
        <div className="px-5 py-6 border-b border-brand-line">
          <p className="overline">Elvis Beauty</p>
          <p className="font-serif text-xl text-brand-dark mt-1">Admin</p>
        </div>
        <nav className="flex-1 py-3">
          {NAV.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.key}
                to={n.to}
                data-testid={`nav-${n.key}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-5 py-3 text-sm transition-colors border-l-2 ${
                    isActive
                      ? "border-brand-primary text-brand-primary bg-brand-primary/5 font-semibold"
                      : "border-transparent text-brand-dark hover:bg-brand-elevated"
                  }`
                }
              >
                <Icon strokeWidth={1.25} className="w-4 h-4" />
                {n.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="border-t border-brand-line p-5">
          <p className="font-sans text-xs text-brand-muted">{user?.email}</p>
          <button
            onClick={async () => { await logout(); navigate("/admin/login"); }}
            data-testid="admin-logout"
            className="mt-3 flex items-center gap-2 text-sm text-brand-dark hover:text-brand-primary"
          >
            <LogOut strokeWidth={1.25} className="w-4 h-4" />
            Sign out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 min-w-0 overflow-y-auto" data-testid="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
